import { mapGetters } from 'vuex'
export const ConsentVideo = {
	computed: {
		...mapGetters('consent', [
			'canShowVideo'
		])
	},
	methods: {
		updateConsentPreferences() {
			Cookiebot.renew() // eslint-disable-line no-undef
		}
	}
}